// extracted by mini-css-extract-plugin
module.exports = {"root":"root-R9Vi1Oxu6l","centered":"centered-iQQOEicKAN"};